export const SET_TOKEN = 'SET_TOKEN';
export const RESET_TOKEN = 'RESET_TOKEN';
export const LOGOUT = 'LOGOUT';
export const LOGIN = 'LOGIN';
export const LOGIN_START = `${LOGIN}_START`;
export const LOGIN_SUCCESS = `${LOGIN}_SUCCESS`;
export const LOGIN_ERROR = `${LOGIN}_ERROR`;
export const VERIFY_TWO_FACTOR = 'VERIFY_TWO_FACTOR';
export const VERIFY_TWO_FACTOR_START = `${VERIFY_TWO_FACTOR}_START`;
export const VERIFY_TWO_FACTOR_SUCCESS = `${VERIFY_TWO_FACTOR}_SUCCESS`;
export const VERIFY_TWO_FACTOR_ERROR = `${VERIFY_TWO_FACTOR}_ERROR`;
export const CREATE_PASSWORD = 'CREATE_PASSWORD';
export const CREATE_PASSWORD_START = `${CREATE_PASSWORD}_START`;
export const CREATE_PASSWORD_SUCCESS = `${CREATE_PASSWORD}_SUCCESS`;
export const CREATE_PASSWORD_ERROR = `${CREATE_PASSWORD}_ERROR`;
//# sourceMappingURL=actionTypes.js.map